import React, {
  useEffect,
  useState,
} from "react";

import {
  FiPlus,
  FiTrash2,
} from "react-icons/fi";

import LabelArea from "./LabelArea";
import Error from "./Error";
import InputAreaPrice from "./InputAreaPrice";

import VehicleCategoryServices from "services/VehicleCategoryServices";

const EMPTY_ROW = () => ({
  rowId: Date.now() + Math.random(),
  vehicleId: "",
  margin: "",
});

const DynamicOverrideMarginInput = ({
  register,
  trigger,
  errors,
  setValue,
  marginData,
  id,
}) => {

  const [vehicleCategory, setVehicleCategory] =
    useState([]);

  const [vehicleRows, setVehicleRows] =
    useState([EMPTY_ROW()]);

  useEffect(() => {
    loadVehicleCategories();
  }, []);

  const loadVehicleCategories = async () => {
    try {

      const response =
        await VehicleCategoryServices.getAllVehicleCategory();

      setVehicleCategory(
        response?.data || []
      );

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

    if (!id) {

      setVehicleRows([
        EMPTY_ROW(),
      ]);

      return;
    }

    if (!marginData)
      return;

    const margins =
      marginData.margin || {};

    const rows =
      Object.entries(margins).map(
        ([vehicleId, margin]) => ({

          rowId:
            Date.now() +
            Math.random(),

          vehicleId:
            String(vehicleId),

          margin:
            margin ?? "",

        })
      );

    if (rows.length) {

      setVehicleRows(rows);

      rows.forEach((row) => {

        setValue(
          `margin.${row.vehicleId}`,
          row.margin
        );

      });

    } else {

      setVehicleRows([
        EMPTY_ROW(),
      ]);

    }

  }, [
    id,
    marginData,
    setValue,
  ]);

  const addRow = () => {
    if (vehicleRows.length >= vehicleCategory.length) {
      return;
    }

    setVehicleRows((prev) => [
      ...prev,
      EMPTY_ROW(),
    ]);
  };

  const removeRow = (rowId) => {
    setVehicleRows((prev) => {
      const row = prev.find(
        (item) => item.rowId === rowId
      );

      if (row?.vehicleId) {
        setValue(
          `margin.${row.vehicleId}`,
          undefined,
          {
            shouldDirty: true,
            shouldValidate: false,
          }
        );
      }

      const updated = prev.filter(
        (item) => item.rowId !== rowId
      );

      return updated.length
        ? updated
        : [EMPTY_ROW()];
    });
  };

  const handleVehicleChange = (
    index,
    vehicleId
  ) => {
    setVehicleRows((prev) => {
      const updated = [...prev];

      const oldVehicle =
        updated[index].vehicleId;

      if (
        oldVehicle &&
        oldVehicle !== vehicleId
      ) {
        setValue(
          `margin.${oldVehicle}`,
          undefined,
          {
            shouldDirty: true,
            shouldValidate: false,
          }
        );
      }

      updated[index] = {
        ...updated[index],
        vehicleId,
        margin: "",
      };

      return updated;
    });

    setValue(
      `margin.${vehicleId}`,
      "",
      {
        shouldDirty: true,
        shouldValidate: false,
      }
    );
  };

  const handleMarginChange = (
    index,
    value
  ) => {
    let input = value.replace(/\D/g, "");

    if (input !== "") {
      input = Number(input);

      if (input > 100) {
        input = 100;
      }

      if (
        input < 0 &&
        input.toString().length >= 2
      ) {
        input = 0;
      }
    }

    setVehicleRows((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        margin: input,
      };

      if (updated[index].vehicleId) {
        setValue(
          `margin.${updated[index].vehicleId}`,
          input,
          {
            shouldDirty: true,
            shouldValidate: true,
          }
        );
      }

      return updated;
    });
  };

  const getAvailableVehicles = (
    currentIndex
  ) => {
    return vehicleCategory.filter(
      (vehicle) =>
        !vehicleRows.some(
          (row, rowIndex) =>
            rowIndex !== currentIndex &&
            row.vehicleId ===
            String(vehicle.id)
        )
    );
  };

  return (
    <div className="mt-6">

      <div className="space-y-5">

        {vehicleRows.map((row, index) => (
          <div
            key={row.rowId}
            className="
              grid
              grid-cols-12
              gap-4
              items-end
              rounded-lg
            "
          >

            <div className="col-span-5">

              <LabelArea
                required
                label="Vehicle Type"
              />

              <select
                value={row.vehicleId}
                onChange={(e) =>
                  handleVehicleChange(
                    index,
                    e.target.value
                  )
                }
                className="
                  w-full
                  h-10
                  rounded-md
                  border
                  border-gray-300
                  bg-white
                  px-3
                  text-sm
                  focus:border-green-500
                  focus:outline-none
                "
              >

                <option value="">
                  -- Select Vehicle --
                </option>

                {getAvailableVehicles(index).map(
                  (vehicle) => (

                    <option
                      key={vehicle.id}
                      value={vehicle.id}
                    >
                      {vehicle.vehicle_type_name}
                    </option>

                  )
                )}

              </select>

            </div>

            <div className="col-span-5">

              <LabelArea
                required
                label="Margin (%)"
              />

              <InputAreaPrice
                isOverrideMargin={true}
                register={register}
                trigger={trigger}
                type="text"
                maxLength={3}
                value={row.margin}
                name={
                  row.vehicleId
                    ? `margin.${row.vehicleId}`
                    : ""
                }
                disabled={!row.vehicleId}
                placeholder="Enter Margin %"
                onChangeFunction={(e) =>
                  handleMarginChange(
                    index,
                    e.target.value
                  )
                }
              />

              <Error
                errorName={
                  errors?.margin?.[
                  row.vehicleId
                  ]
                }
              />

            </div>

            <div className="col-span-2 flex justify-center">

              {vehicleRows.length > 1 && (

                <button
                  type="button"
                  onClick={() =>
                    removeRow(row.rowId)
                  }
                  className="
                    h-10
                    w-10
                    rounded-md
                    border
                    border-red-300
                    flex
                    items-center
                    justify-center
                    text-red-500
                    hover:bg-red-50
                    hover:border-red-500
                    transition-all
                  "
                >
                  <FiTrash2 size={17} />
                </button>

              )}

            </div>

          </div>

        ))}

      </div>

      <div className="flex items-center justify-end my-4">

        <button
          type="button"
          onClick={addRow}
          disabled={
            vehicleRows.length >=
            vehicleCategory.length
          }
          className="
            flex
            items-center
            gap-2
            rounded-lg
            bg-green-600
            px-4
            py-2
            text-sm
            font-medium
            text-white
            hover:bg-green-700
            disabled:bg-gray-300
            disabled:cursor-not-allowed
          "
        >
          <FiPlus />
          Add Vehicle
        </button>

      </div>

    </div>
  );
};

export default DynamicOverrideMarginInput;